export const PHOTOS = [
  {
    label: "id",
    icon: "fa-regular:id-card",
    checked: false,
  },
  {
    label: "plates",
    icon: "fa-solid:car-alt",
    checked: false,
  },
  {
    label: "visitor",
    icon: "fa-solid:user",
    checked: false,
  },
  {
    label: "other",
    icon: "fa-solid:laptop",
    checked: false,
  },
];
